"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSyntheticDepositListSchema = exports.UserSyntheticDepositSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
exports.UserSyntheticDepositSchema = zod_1.z.object({
    id: zod_1.z.string({ required_error: 'id is required' }),
    syntheticID: zod_1.z.string({ required_error: 'syntheticID is required' }),
    depositDate: zod_1.z.string().datetime(), // ISO 8601
    unlockDate: zod_1.z.string().datetime(), // ISO 8601,
    lastUpdateDate: zod_1.z.string().datetime(), // ISO 8601
    deposited: core_contracts_ifaces_1.TokenAmountSchema,
    syntheticAmount: core_contracts_ifaces_1.TokenAmountSchema,
});
exports.UserSyntheticDepositListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.UserSyntheticDepositSchema),
    total: zod_1.z.array(core_contracts_ifaces_1.CurrencyAmountSchema),
});
